import { useCallback } from 'react'

import toNumber from 'lodash/toNumber'
import { config } from '../../../Init/Init'
import { tokenizer } from '../../../../services/utils'
import { usePost } from '../../../../hooks/apiHooks'
import { withdrawFormFields, withdrawalSteps } from '../../cryptoPaymentConstants'
import { usePlayerStore } from '../../../../services/store'

export const useCreateDraftWithdrawal = ({
  loading,
  setLoading,
  isXRPCryptoType,
  setWithdrawalStep,
  setWithdrawalFormError,
  setWithdrawalDraftData,
  handleDraftWithdrawalError
}) => {
  const playerStore = usePlayerStore()
  const playerUserId = playerStore.use.userId()

  const { POST } = usePost()

  const onWithdrawalDraftCreate = useCallback(
    values => {
      if (loading) {
        return
      }

      setWithdrawalFormError('')
      setLoading(true)

      const formData = {
        [withdrawFormFields.address]: values.address,
        [withdrawFormFields.amountInTargetCurrency]: toNumber(values.amountInTargetCurrency.replace(/,/g, '')),
        [withdrawFormFields.currency]: values.currency,
        [withdrawFormFields.destinationTag]: isXRPCryptoType ? toNumber(values.destinationTag) : null,
        [withdrawFormFields.protocol]: values.protocol,
        [withdrawFormFields.targetCurrency]: values.targetCurrency
      }

      return POST(
        config.paymentsUrl +
          tokenizer(config.createWithdrawalDraftUrl, {
            '{userId}': playerUserId
          }),
        formData
      )
        .then(async response => {
          if (response.errorCode) {
            handleDraftWithdrawalError(response.errorCode)
          } else {
            setWithdrawalStep(withdrawalSteps.submit)
            setWithdrawalDraftData(response)
          }
        })
        .catch(handleDraftWithdrawalError)
        .finally(() => setLoading(false))
    },
    [
      POST,
      loading,
      setLoading,
      playerUserId,
      isXRPCryptoType,
      setWithdrawalStep,
      setWithdrawalFormError,
      setWithdrawalDraftData,
      handleDraftWithdrawalError
    ]
  )

  return { onWithdrawalDraftCreate }
}
